import React, { Component } from "react";
import service from "../../core/service";
import * as yup from "yup";
import { fixNumbers } from "../../core/utils";
import { toast } from "react-toastify";
import axios from "axios";
import { AppConstants } from "../../core/constants";
import Cookies from "js-cookie";

interface IProps {
  dispatch?: any;
  userData?: any;
}
interface AgentData {
  message: string;
  data: Array<{
    default?: number;
    values?: Array<{ value: number; title: string }>;
    type?: string;
    name: string;
    unit?: string | null;
    value?: any;
  }>;
}
interface ApiResponse {
  status: number;
  data: AgentData;
}
interface IState {
  BrkrType: any;
  CityId: any;
  BrkrName: string;
  birthDate: any;
  ManagerName: string;
  Mobile: string;
  GrantDate: any;
  ExpireDate: any;
  Address: any;
  Tel: any;
  agent_list: any;
  inquiryLoading: boolean;
  license_code: string;
  national_id: string;
  upload_list: any;
  uploadError: any;
  fileUpload: any;
  file: any;
  policy_city_list: any;
  brag_id: any;
  step1Errors?: any;
  phone?: any;
  brag_type: any;
  upload_type?: any;
  dropdownOptions?: any;
  dropdownOptionsUpload?: any;
  branch?: any;
  value: any;
  step: number;
  currentPage: number;
  result: any;
  data?: any;
  options?: any;
  startDate?: any;
  person?: any;
  prevJob?: string;
  limitationInquiry: any;
  allLimitationInquiry: any;
  contract_id: string;
  premium_annually: string;
  adjustment_coefficient_death_benefit: string;
  start_death_asset: string;
  errors: any;
  holder_birthday: any;
  insured_birthday: any;
  selfsame: boolean;
  policy_holder_job_category: string;
  insured_job_category: string;

  policy_holder_job_category_title: string;
  insured_job_category_title: string;
  jobListInquiryLoading: boolean;
  jobListInquiry: any;
  jobListHolder: any;
  jobListHolderLoading: boolean;
  tab: number;
  showInfo: boolean;
  contractSelected: string;
  contractNumberErrors: any;
  contentLoading: boolean;
  base64Loading: boolean;
  name: any;
  agent_is_married: string;
  projectDetails: any;
  uploadedImage: any;
  province_list?: any;
  policy_holder_province_id: any;
  cityListLoading?: any;
  policy_holder_city_id: string;
  insured_city_list: any;
  insured_province_id: string;
  cityListfiltered: any;
  openModal:boolean
}

export class AgentController extends Component<IProps, IState> {
  datePickerRefHolder: any;
  datePickerRefInsured: any;

  constructor(props: any) {
    super(props);
    this.datePickerRefHolder = React.createRef();
    this.datePickerRefInsured = React.createRef();
  }

  state: IState = {
    CityId: null,
    BrkrType: "",
    BrkrName: "",
    birthDate: this.props.userData?.birthdate,
    ManagerName: "",
    Mobile: "",
    GrantDate: "",
    ExpireDate: "",
    Address: "",
    Tel: "",
    agent_list: [],
    inquiryLoading: false,
    national_id: "",
    license_code: "",
    upload_list: [],
    uploadError: [],
    fileUpload: "",
    file: "",
    brag_id: null,
    cityListfiltered: [],
    insured_province_id: "",
    insured_city_list: [],
    policy_holder_city_id: "",
    policy_city_list: [],
    cityListLoading: false,
    policy_holder_province_id: "",
    province_list: [],
    upload_type: [],
    uploadedImage: "",
    step1Errors: [],
    brag_type: [],
    projectDetails: "",
    agent_is_married: "",
    phone: null,
    dropdownOptions: [],
    dropdownOptionsUpload: [],
    prevJob: "",
    branch: [],
    person: this.props.userData?.national_code,
    startDate: "",
    name: "",
    value: "0.1",
    step: 1,
    currentPage: 0,
    result: [],
    data: {
      labels: [],
      datasets: [],
    },
    selfsame: false,

    options: {},
    limitationInquiry: [],
    allLimitationInquiry: [],
    contract_id: "",
    premium_annually: "",
    adjustment_coefficient_death_benefit: "",
    start_death_asset: "",
    errors: [],
    insured_birthday: "",
    holder_birthday: "",

    policy_holder_job_category: "",
    insured_job_category: "",

    policy_holder_job_category_title: "",
    insured_job_category_title: "",
    jobListInquiryLoading: false,
    jobListInquiry: [],
    jobListHolder: [],
    jobListHolderLoading: false,
    tab: 0,
    showInfo: false,
    contractSelected: "0",
    contractNumberErrors: [],
    contentLoading: false,
    base64Loading: false,
    openModal:false
  };

  handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // if (event.target.value != "" && parseInt(event.target.value) !== 0) {
    if (event.target.value != "") {
      if (parseInt(event.target.value) < parseInt("0.1")) {
        // event.target.value = "0.1";
        this.setState({ value: Number("0.1") });
      } else if (parseInt(event.target.value) > parseInt("100")) {
        // event.target.value = "100";
        this.setState({ value: Number("100") });
      } else {
        this.setState({ value: Number(event.target.value) });
      }
    }
  };

  async checkStep1() {
    const { license_code } = this.state;

    const shebaCodeSchema = yup.object({
      license_code: yup.string().required("کد پروانه الزامی است").max(5, "  کد پروانه کمتر از 5 کاراکتر نمی باشد "),
    });

    try {
      await shebaCodeSchema.validate(
        { license_code: this.state.license_code },
        { abortEarly: false }
      );

      this.setState({ step1Errors: [] });
      return true;
    } catch (err: any) {
      this.setState({ step1Errors: err.inner });
      return false;
    }
  }

  async checkStep2() {
    const shebaCodeSchema = yup.object({
      national_id: yup.string().required("شناسه ملی الزامی است").length(11, "شناسه ملی باید 11 رقمی باشد."),
    });

    try {
      await shebaCodeSchema.validate(
        { national_id: this.state.national_id },
        { abortEarly: false }
      );

      this.setState({ step1Errors: [] });
      return true;
    } catch (err: any) {
      this.setState({ step1Errors: err.inner });
      return false;
    }
  }

  increaseSteper = async () => {
    const { brag_type, step } = this.state;

    if (step === 1) {
      const isValid = await this.checkStep1();
      if (!isValid) return;

      try {
        const response = await this.getDefaultAgent();

        if (response && (response.status === 200 || response.status === 201)) {
          this.setState({
            step: step + (response?.data?.data[0]?.default === 4 ? 2 : 1),
          });
        } else {
          toast.error("استعلام شما با مشکل مواجه شده است");
          this.setState({ inquiryLoading: false });
        }
      } catch (error) {
        toast.error("ثبت پیشنهاد شما با مشکل مواجه شده است");
      }
    } else if (step === 2) {
      const isValid = await this.checkStep2();
      if (!isValid) return;


      this.getCompanyInquiry()
      

    } else if (step === 3) {
    

      try {
        const response = await this.createAgent();

        if (response && (response.status === 200 || response.status === 201)) {
          this.setState({ step: step + 1 });
          toast.success(response?.data?.message);
        } else {
          toast.error(response?.data?.message || "خطایی رخ داده است");
        }
      } catch (error) {
        toast.error("ثبت پیشنهاد شما با مشکل مواجه شده است");
      }
    }
  };

  async createAgent() {
    const {
      Address,
      brag_type,
      Mobile,
      person,
      ManagerName,
      birthDate,
      national_id,
      CityId,
      license_code
    } = this.state;

    this.setState({
      contentLoading: true,
      step1Errors: [],
    });

    try {
      const response = await service.Agent.create({
        brag_type_id: brag_type,
        city_id: CityId,
        brag_name: ManagerName,
        person_national_code: national_id ? national_id : person,
        birthday: birthDate,
        mobile: Mobile,
        address: Address,
        centinsur_code:license_code
      });

      if (response?.status === 200 || response?.status === 201) {
        this.setState({
          contentLoading: false,
        });
        const bragId = response?.data?.data?.new_brag_code;
        this.setState({
          brag_id: bragId,
          contentLoading: false,
        });
        return response;
      } else {
        this.setState({
          step1Errors: response?.data?.errors || [],
          contentLoading: false,
        });
        return response;
      }
    } catch (err: any) {
      toast.error("ثبت  شما با مشکل مواجه شده است");
      this.setState({
        contentLoading: false,
      });
      return null;
    }
  }

  getDefaultAgent = async (): Promise<ApiResponse | null> => {
    this.setState({ inquiryLoading: true });

    try {
      const response: ApiResponse = await service.limitationBrag.bragDefault({
        license_code: this.state.license_code,
      });

      if (response?.status === 200 || response?.status === 201) {
        const data = response?.data?.data || [];

        const informationData =
          data.find((item: any) => item.name === "information_centinsur")
            ?.value || {};

        const findFieldData = (name: string) => {
          const field = data.find((item: any) => item.name === name);
          return field
            ? { default: field.default, values: field.values }
            : { default: null, values: [] };
        };

        const bragTypeData = findFieldData("brag_type");

        this.setState({
          brag_type: bragTypeData.default,
          dropdownOptions: {
            brag_type: bragTypeData.values,
          },
          contentLoading: false,
        });

        this.setState({
          CityId: informationData?.CityId || "",
          BrkrName: informationData?.BrkrName || "",
          BrkrType: informationData?.BrkrType || "",
          ManagerName: informationData?.ManagerName || "",
          Mobile: informationData?.Mobile || "",
          GrantDate: informationData?.GrantDate || "",
          ExpireDate: informationData?.ExpireDate || "",
          Address: informationData?.Address || "",
          Tel: informationData?.Tel || "",
          inquiryLoading: false,
        });

        return response;
      }
    } catch (error: any) {
      console.error("Error fetching default agent data:", error);

      this.setState({ inquiryLoading: false });

      if (error?.response?.status === 400) {
        toast.error("خطایی رخ داده است");
        this.setState({ inquiryLoading: false });
      }
    }

    return null;
  };

  async uploadImage(event: any) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }
    if (file.type === "image/svg+xml") {
      toast.error("آپلود فایل SVG مجاز نمی‌باشد.");
      return;
    }
    if (file.size === 0) {
      toast.error("آپلود فایل با حجم صفر مجاز نمی‌باشد.");
      return;
    }
    if (file.size > 1 * 1024 * 1024) {
      toast.error("حجم فایل نباید بیشتر از 1 مگابایت باشد.");
      return;
    }

    const reader = new FileReader();
    reader?.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({ file: reader.result });
    };

    this.setState({ fileUpload: file });
  }

  async uploadFile() {
    const { brag_id, upload_type, fileUpload } = this.state;
    if (!fileUpload) {
      this.setState({
        uploadError: [{ path: "fileUpload", errors: ["لطفاً یک فایل برای آپلود انتخاب کنید"] }],
      });
      return;
    }
    const shebaCodeSchema = yup.object({
      fileUpload: yup.mixed().required("فایل اجباری می باشد"),
      upload_type: yup.string().required("نوع سند دریافتی اجباری می باشد"),
    });

    try { 
    this.setState({ inquiryLoading: true }); 
      await shebaCodeSchema.validate(
        { upload_type, fileUpload },
        { abortEarly: false }
      );

      const formData = new FormData();
      formData.append("attachments", fileUpload);
      formData.append("type", upload_type);
      formData.append("brag_id", fixNumbers(brag_id));
      formData.append("descr", "-");

      const response = await service.Agent.upload(formData);

      if (response?.status === 200 || response?.status === 201) {
    this.setState({ inquiryLoading: false }); 

        toast.success(response?.data?.message);
        this.setState({ fileUpload: null, upload_type: "", uploadError: [] , openModal:false , file: ""}); 
        window.location.href = "/agent-edit";
      } else {
    this.setState({ inquiryLoading: false }); 

        toast.error("خطایی در آپلود رخ داد.");
      }
    } catch (err: any) {
    this.setState({ inquiryLoading: false }); 

      this.setState({
        uploadError: Array.isArray(err.inner) ? err.inner : [],
      });
    }
  }

  async agentUploadList() {
    const { brag_id } = this.state;

    this.setState({
      contentLoading: true,
    });

    try {
      const response = await service.Agent.uploadList({
        brag_id: brag_id,
      });

      if (response?.status === 200 || response?.status === 201) {
        this.setState({
          contentLoading: false,
        });
        this.setState({
          upload_list: response?.data?.data,
          contentLoading: false,
        });
        return response;
      } else {
        this.setState({
          contentLoading: false,
        });
        return response;
      }
    } catch (err: any) {
      this.setState({
        contentLoading: false,
      });
      return null;
    }
  }

  getDefaultUpload = async () => {
    try {
      const response = await service.limitationBrag.bragUpload();

      if (response) {
        const data = response.data.data;
        const findFieldData = (name: string) => {
          const field = data.find((item: any) => item.name === name);
          return field
            ? { default: field.default, values: field.values }
            : { default: null, values: [] };
        };

        const uploadType = findFieldData("type");

        this.setState({
          upload_type: uploadType.default,
          dropdownOptionsUpload: {
            brag_id: uploadType.values,
          },
          contentLoading: false,
        });
      }
    } catch (error: any) {
      this.setState({ contentLoading: false });
      if (error?.status === 400) {
        toast.error("خطایی رخ داده است");
      }
    }
  }
  getCompanyInquiry = async () => {
    this.setState({ inquiryLoading: true });
  
    try {
      const response = await service.limitationBrag.companyInquiry({
        national_code:this.state.national_id
      });
       if (response.status === 200){
        this.setState((prevState) => ({
          inquiryLoading: false,
          step: response ? prevState.step + 1 : prevState.step
        }));
        } else{
            toast.error(response?.data?.message[0]);
            this.setState({ inquiryLoading: false });
        }
     
    } catch (error) {
      this.setState({ inquiryLoading: false });
    }
  };

      async getBragAgreement() {
        this.setState({ base64Loading: true })
       
        const {
          brag_id
        } = this.state;
        try {
      
          const response = await axios.post(
            `${AppConstants.base_url_api}brag-agreement/`,
            {
              license_code:brag_id
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization:  `${Cookies.get('acto')}`,
              },
              responseType: "blob", 
            }
          );
          if (response) {
          
      
          this.setState({ base64Loading: false })
          try {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        // this.setState({ base64Data: url })
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.pdf"); // نام فایل
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
          } catch (error) {
            console.error("خطایی رخ داد:", error   );
            this.setState({ base64Loading: false })
          } 
          }else{
      this.setState({ base64Loading: false })

          }
        } catch (err: any) {
       
        }
      };


closeModal = () => {
 this.setState({openModal:false})
 this.setState({ fileUpload: "", file: "" })
}
}
export default AgentController;
